import { collectImageComponentParams } from '../shared/collector';

import { VectorizerStrapiComponent } from './types';

export const collectVectorizerComponentParams = (
  data: VectorizerStrapiComponent
) => {
  return {
    background: collectImageComponentParams(data.background),
    title: data.title,
    subline: data.subline,
  };
};
